// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"82fa3e79","977":"4288e1ed"}[chunkId] + ".chunk.js";
};